export default __webpack_public_path__ + "static/media/info-icon.cef187f2.svg";